<script>
	// The params prop contains values matched from the URL
	export let params = {} 

	import { createEventDispatcher, onMount } from 'svelte';
	import { replace } from 'svelte-spa-router';
	import { 
		gerarStringAleatoria, 
		StatusHttp, 
		TipoEvento,
		cabecalhoPadraoRequisicao,
		API, 
		TextoFeedback } from '../../utils';
	import { sCaptcha } from '../../stores';
	import TBox from '../templates/TBox.svelte';
	import Captcha from '../../componentes/Captcha.svelte';

	const dispatch = createEventDispatcher();
	
	// variáveis para trabalhar com os dados do formulário
	let senha, captchaUsuario;
	let tituloAviso = "Erro";
	let feedbackUsuario = [];

	async function submeterFormulario(event) {
		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Executando ...',
		});

		if (captchaUsuario != $sCaptcha) {
			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});
			
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Captcha Inválido',
				conteudo: 'O código informado é inválido, tente novamente.'
			});
			
			// atualiza o store
			sCaptcha.update(novaString => gerarStringAleatoria());
		} else {

			// faz a chamada a API no endpoint cadastrar, envia os dados e aguarda a resposta
			const resposta = await fetch(API('usuarios/atualizar-privilegio-admin'), {
				method: 'PATCH',
				headers: cabecalhoPadraoRequisicao(),
				body: JSON.stringify({
					cpfUsuarioAlvo: params.cpf,
					senha: senha,
					operacao: event.submitter.value
				})
			}).catch(erros => {
				feedbackUsuario.push(TextoFeedback.ERRO_REQUISICAO);
				
				dispatch('routeEvent', { 
					tipo: TipoEvento.ESTA_CARREGANDO,
					valor: false
				});
				
				dispatch('routeEvent', {
					tipo: TipoEvento.ABRIR_MODAL,
					titulo: tituloAviso,
					conteudo: feedbackUsuario[0]
				});
			});

			// pega o json do retorno da resposta
			const json = await resposta.json();

			if (resposta.status == StatusHttp.OK) {		
				dispatch('routeEvent', {
					tipo: TipoEvento.ABRIR_MODAL,
					titulo: 'Tudo certo!',
					conteudo: json?.mensagem
				});

				replace('/usuario/listagem');
			} else {
				feedbackUsuario.push(json?.mensagem ?? 'Erro desconhecido, se persistir, favor entrar em contato.');
			}

			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});

			// exibe feedback pro usuário se existir algo pra exibir
			if (feedbackUsuario[0]) {
				dispatch('routeEvent', {
					tipo: TipoEvento.ABRIR_MODAL,
					titulo: tituloAviso,
					conteudo: feedbackUsuario[0]
				});
			}

			// limpa as mensagens
			feedbackUsuario = [];
		}
	}
</script>

<TBox 
	titulo="Gerenciar Administrador" 
	subtitulo="[CUIDADO] - Adição ou remoção de privilégios de administrador do sistema" 
	largura="8" 
	deslocamento="2" 
	icone="aviso">
	
	<form method="post" on:submit|preventDefault={submeterFormulario}>
		<p>Ao confirmar esta operação, você na qualidade de funcionário Cetreina e também administrador, se responsabiliza pelo usuário ao qual está adicionando ou removendo os privilégios administrativos no sistema. Um administrador pode inclusive bloquear seu acesso e remover o privilégio de administrador de você, pode executar distribuições, desfazer distribuições etc. Um usuário errado com estes privilégios pode comprometer todo o trabalho do setor.</p>
		<small class="has-text-danger">Por motivos de segurança e auditoria, esta operação é registrada e seus dados serão armazenados como o responsável pela ação.</small>
		<hr>
		
		<div class="columns">
			<div class="column is-full">
				<small>Digite sua senha:</small>
				<div class="field">
					<input 
						bind:value={senha}
						name="senha" 
						type="password" 
						placeholder="Informe sua senha" 
						class="input is-large is-primary" required>
				</div>
			</div>
		</div>
		
		<div class="columns is-mobile">
			<div class="column is-half">
				<small>...</small>
				<Captcha />
			</div>
			<div class="column is-half">
				<small>Digite o código aqui:</small>
				<input 
					name="captcha"
					bind:value={captchaUsuario}
					type="text"
					maxlength="8" 
					placeholder="Digite o código aqui" 
					class="input is-large is-primary" required>
			</div>
		</div>

		<p>Selecione uma opção abaixo:</p>
		<br>

		<div class="columns">
			<div class="column">
				<p class="control">
					<a href="#/painel/usuarios" class="button is-black is-medium is-outlined is-fullwidth">Voltar</a>
				</p>
			</div>
			<div class="column is-4">
				<p class="control">
					<button 
						type="submit" 
						value="OPERACAO_ADICIONAR_ADMIN"
						class="button is-success is-medium is-fullwidth">
						Adicionar
					</button>
				</p>
			</div>
			<div class="column is-4">
				<p class="control">
					<button 
						type="submit" 
						value="OPERACAO_REMOVER_ADMIN"
						class="button is-danger is-medium is-fullwidth">
						Remover
					</button>
				</p>
			</div>
		</div>
	</form>
</TBox>